/* tslint:disable */
/* eslint-disable */
/**
 * NORA Api
 *  ## Headers  ### X-App-Version  Remember to include the `X-App-Version` header in every request. This will verify that the app version works with this API version. The API will return a `X-Minimum-App-Version` header as well including the minimum app version that is supported by this API. The contents of the header are is a JSON encoded DTO, `VersionHeaderDTO`. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResult } from '../models';
// @ts-ignore
import type { AttachmentMimeTypeFilter } from '../models';
// @ts-ignore
import type { GetAttachmentsForConversation200Response } from '../models';
// @ts-ignore
import type { GetAttachmentsForConversationSortByParameter } from '../models';
// @ts-ignore
import type { SearchConversations200Response } from '../models';
// @ts-ignore
import type { SearchConversationsAndMessages200Response } from '../models';
// @ts-ignore
import type { SearchMessages200Response } from '../models';
// @ts-ignore
import type { SortOrder } from '../models';
/**
 * ChatSearchApi - axios parameter creator
 */
export const ChatSearchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary searchAttachments
         * @param {string} [query] 
         * @param {AttachmentMimeTypeFilter} [filter] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {SortOrder} [sortOrder] 
         * @param {string} [cursor] Deprecated. Ignored; use skip for offset pagination.
         * @param {GetAttachmentsForConversationSortByParameter} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAttachments: async (query?: string, filter?: AttachmentMimeTypeFilter, skip?: number, limit?: number, sortOrder?: SortOrder, cursor?: string, sortBy?: GetAttachmentsForConversationSortByParameter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/chat/search/attachment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary searchConversations
         * @param {string} [query] 
         * @param {string} [filter] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {SortOrder} [sortOrder] 
         * @param {string} [cursor] 
         * @param {string} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchConversations: async (query?: string, filter?: string, skip?: number, limit?: number, sortOrder?: SortOrder, cursor?: string, sortBy?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/chat/search/conversation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary searchConversationsAndMessages
         * @param {string} [query] 
         * @param {string} [filter] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {SortOrder} [sortOrder] 
         * @param {string} [cursor] 
         * @param {string} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchConversationsAndMessages: async (query?: string, filter?: string, skip?: number, limit?: number, sortOrder?: SortOrder, cursor?: string, sortBy?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/chat/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary searchMessages
         * @param {string} [query] 
         * @param {string} [filter] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {SortOrder} [sortOrder] 
         * @param {string} [cursor] 
         * @param {string} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchMessages: async (query?: string, filter?: string, skip?: number, limit?: number, sortOrder?: SortOrder, cursor?: string, sortBy?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/chat/search/message`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChatSearchApi - functional programming interface
 */
export const ChatSearchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChatSearchApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary searchAttachments
         * @param {string} [query] 
         * @param {AttachmentMimeTypeFilter} [filter] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {SortOrder} [sortOrder] 
         * @param {string} [cursor] Deprecated. Ignored; use skip for offset pagination.
         * @param {GetAttachmentsForConversationSortByParameter} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchAttachments(query?: string, filter?: AttachmentMimeTypeFilter, skip?: number, limit?: number, sortOrder?: SortOrder, cursor?: string, sortBy?: GetAttachmentsForConversationSortByParameter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAttachmentsForConversation200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchAttachments(query, filter, skip, limit, sortOrder, cursor, sortBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatSearchApi.searchAttachments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary searchConversations
         * @param {string} [query] 
         * @param {string} [filter] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {SortOrder} [sortOrder] 
         * @param {string} [cursor] 
         * @param {string} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchConversations(query?: string, filter?: string, skip?: number, limit?: number, sortOrder?: SortOrder, cursor?: string, sortBy?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchConversations200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchConversations(query, filter, skip, limit, sortOrder, cursor, sortBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatSearchApi.searchConversations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary searchConversationsAndMessages
         * @param {string} [query] 
         * @param {string} [filter] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {SortOrder} [sortOrder] 
         * @param {string} [cursor] 
         * @param {string} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchConversationsAndMessages(query?: string, filter?: string, skip?: number, limit?: number, sortOrder?: SortOrder, cursor?: string, sortBy?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchConversationsAndMessages200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchConversationsAndMessages(query, filter, skip, limit, sortOrder, cursor, sortBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatSearchApi.searchConversationsAndMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary searchMessages
         * @param {string} [query] 
         * @param {string} [filter] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {SortOrder} [sortOrder] 
         * @param {string} [cursor] 
         * @param {string} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchMessages(query?: string, filter?: string, skip?: number, limit?: number, sortOrder?: SortOrder, cursor?: string, sortBy?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchMessages200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchMessages(query, filter, skip, limit, sortOrder, cursor, sortBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatSearchApi.searchMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChatSearchApi - factory interface
 */
export const ChatSearchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChatSearchApiFp(configuration)
    return {
        /**
         * 
         * @summary searchAttachments
         * @param {ChatSearchApiSearchAttachmentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAttachments(requestParameters: ChatSearchApiSearchAttachmentsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAttachmentsForConversation200Response> {
            return localVarFp.searchAttachments(requestParameters.query, requestParameters.filter, requestParameters.skip, requestParameters.limit, requestParameters.sortOrder, requestParameters.cursor, requestParameters.sortBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary searchConversations
         * @param {ChatSearchApiSearchConversationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchConversations(requestParameters: ChatSearchApiSearchConversationsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SearchConversations200Response> {
            return localVarFp.searchConversations(requestParameters.query, requestParameters.filter, requestParameters.skip, requestParameters.limit, requestParameters.sortOrder, requestParameters.cursor, requestParameters.sortBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary searchConversationsAndMessages
         * @param {ChatSearchApiSearchConversationsAndMessagesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchConversationsAndMessages(requestParameters: ChatSearchApiSearchConversationsAndMessagesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SearchConversationsAndMessages200Response> {
            return localVarFp.searchConversationsAndMessages(requestParameters.query, requestParameters.filter, requestParameters.skip, requestParameters.limit, requestParameters.sortOrder, requestParameters.cursor, requestParameters.sortBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary searchMessages
         * @param {ChatSearchApiSearchMessagesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchMessages(requestParameters: ChatSearchApiSearchMessagesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SearchMessages200Response> {
            return localVarFp.searchMessages(requestParameters.query, requestParameters.filter, requestParameters.skip, requestParameters.limit, requestParameters.sortOrder, requestParameters.cursor, requestParameters.sortBy, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for searchAttachments operation in ChatSearchApi.
 */
export interface ChatSearchApiSearchAttachmentsRequest {
    readonly query?: string

    readonly filter?: AttachmentMimeTypeFilter

    readonly skip?: number

    readonly limit?: number

    readonly sortOrder?: SortOrder

    /**
     * Deprecated. Ignored; use skip for offset pagination.
     */
    readonly cursor?: string

    readonly sortBy?: GetAttachmentsForConversationSortByParameter
}

/**
 * Request parameters for searchConversations operation in ChatSearchApi.
 */
export interface ChatSearchApiSearchConversationsRequest {
    readonly query?: string

    readonly filter?: string

    readonly skip?: number

    readonly limit?: number

    readonly sortOrder?: SortOrder

    readonly cursor?: string

    readonly sortBy?: string
}

/**
 * Request parameters for searchConversationsAndMessages operation in ChatSearchApi.
 */
export interface ChatSearchApiSearchConversationsAndMessagesRequest {
    readonly query?: string

    readonly filter?: string

    readonly skip?: number

    readonly limit?: number

    readonly sortOrder?: SortOrder

    readonly cursor?: string

    readonly sortBy?: string
}

/**
 * Request parameters for searchMessages operation in ChatSearchApi.
 */
export interface ChatSearchApiSearchMessagesRequest {
    readonly query?: string

    readonly filter?: string

    readonly skip?: number

    readonly limit?: number

    readonly sortOrder?: SortOrder

    readonly cursor?: string

    readonly sortBy?: string
}

/**
 * ChatSearchApi - object-oriented interface
 */
export class ChatSearchApi extends BaseAPI {
    /**
     * 
     * @summary searchAttachments
     * @param {ChatSearchApiSearchAttachmentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchAttachments(requestParameters: ChatSearchApiSearchAttachmentsRequest = {}, options?: RawAxiosRequestConfig) {
        return ChatSearchApiFp(this.configuration).searchAttachments(requestParameters.query, requestParameters.filter, requestParameters.skip, requestParameters.limit, requestParameters.sortOrder, requestParameters.cursor, requestParameters.sortBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary searchConversations
     * @param {ChatSearchApiSearchConversationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchConversations(requestParameters: ChatSearchApiSearchConversationsRequest = {}, options?: RawAxiosRequestConfig) {
        return ChatSearchApiFp(this.configuration).searchConversations(requestParameters.query, requestParameters.filter, requestParameters.skip, requestParameters.limit, requestParameters.sortOrder, requestParameters.cursor, requestParameters.sortBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary searchConversationsAndMessages
     * @param {ChatSearchApiSearchConversationsAndMessagesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchConversationsAndMessages(requestParameters: ChatSearchApiSearchConversationsAndMessagesRequest = {}, options?: RawAxiosRequestConfig) {
        return ChatSearchApiFp(this.configuration).searchConversationsAndMessages(requestParameters.query, requestParameters.filter, requestParameters.skip, requestParameters.limit, requestParameters.sortOrder, requestParameters.cursor, requestParameters.sortBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary searchMessages
     * @param {ChatSearchApiSearchMessagesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchMessages(requestParameters: ChatSearchApiSearchMessagesRequest = {}, options?: RawAxiosRequestConfig) {
        return ChatSearchApiFp(this.configuration).searchMessages(requestParameters.query, requestParameters.filter, requestParameters.skip, requestParameters.limit, requestParameters.sortOrder, requestParameters.cursor, requestParameters.sortBy, options).then((request) => request(this.axios, this.basePath));
    }
}

